<template>
  <div class="table-responsive py-5 px-6">
    <div class="d-flex mb-5 justify-content-start align-items-center">
      <div class="fw-bold text-gray-900 fs-2x text-decoration-underline me-5">
        {{ table.name }}
      </div>
      <div>

        <button v-if="$can( abilities.VIEW_PROJECT_FORMALITIES)" title="Modifier le tableau" type="button" @click.prevent="editTable(table, tableKey)" class="btn btn-sm me-2 btn-primary">
          <i class="fa fa-edit p-0"></i>
        </button>

        <button v-if="$can( abilities.DELETE_PROJECT_FORMALITIES)" title="Supprimer le tableau" type="button" @click.prevent="deleteTable(tableKey)" class="btn btn-sm btn-danger">
          <i class="fa fa-trash p-0"></i>
        </button>
      </div>
    </div>
    <table class="formality table-rounded table table-bordered mb-10">
      <thead class="position-relative">
      <tr class="fw-bold fs-6 text-gray-800">
        <th :title="column.name" v-for="(column, key) in table.columns" :key="key" class="truncate-table text-center fw-boldest fs-4 px-6 position-relative">
          <div>
            {{ abbreviate(column.name) }}
          </div>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(line, lineKey) in table.lines" class="fw-bold fs-6 text-gray-800 position-relative">
        <td v-for="(column, key) in table.columns" :key="key" class="text-center px-4">
          <div class="">{{ line[key] || '' }}</div>
        </td>
      </tr>
      </tbody>

    </table>
  </div>
</template>

<script setup>
  import abilities from "@/composables/abilities";

  const props = defineProps({
    table: {
      type: Object,
      required: true
    },
    editTable: {
      type: Function,
      required: true
    },
    deleteTable: {
      type: Function,
      required: true
    },
    tableKey: {
      required: true
    }
  })

  function abbreviate(text, maxLength = 20) {
    return text.length > maxLength ? text.slice(0, maxLength) + '…' : text;
  }
</script>

<style scoped>
.formality.table {
  --bs-table-color: #212529;
  --bs-table-bg: transparent;
  --bs-table-border-color: #dee2e6;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: #212529;
  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
  --bs-table-active-color: #212529;
  --bs-table-active-bg: rgba(0, 0, 0, 0.1);
  --bs-table-hover-color: #212529;
  --bs-table-hover-bg: rgba(0, 0, 0, 0.075);
  width: 100%;
  margin-bottom: 1rem;
  color: var(--bs-table-color);
  vertical-align: top;
  border-color: var(--bs-table-border-color);
  border-collapse: collapse;
}

.formality.table-bordered > :not(caption) > * {
  border-width: 1px 1px;
  border-style: solid;
  border-color: var(--bs-table-border-color);
}

.formality.table-bordered th,
.formality.table-bordered td {
  border: 1px solid #dee2e6;
}

.formality.table-bordered tbody tr:last-child {
  border-bottom: 1px solid var(--bs-table-border-color) !important;
}

.table_button {
  opacity: 0;
}

.formality:hover .table_button{
  opacity: 0.5;
}

.table_button:hover {
  opacity: 1 !important;
}

.truncate-table {
  overflow: hidden;
  white-space: nowrap;
  max-width: 200px;
}

</style>